/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 03 2023
 **/

import { Button, Typography, useModal, useToast } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import { useGroup } from "@/frameworks/core/API";

import * as S from "./emotion";
import { ModalID } from "@/frameworks/core/commons";
import { EventID } from "@/frameworks/core/commons";
import { EventHandler } from "@rfice/eventhandler";
import queryClient from "@/frameworks/core/API/private/QueryClient";
import { GroupActions } from "@/frameworks/core/persistence";
import { GroupCacheOption } from "@/frameworks/core/persistence/groups/actions";

export default function LeaveMember({ name, groupID }: { name: string; groupID: string }) {
	const modal = useModal();
	const toast = useToast();

	const groupAPI = useGroup();
	const handleLeave = async () => {
		try {
			await groupAPI.user.leave.execute({ groupId: groupID });
			EventHandler.emit(EventID.onGroupCommand, "leave");
			toast.show({ type: "success", message: "탈퇴되었습니다." });
			// Update 21/02/2025: Update list group to  group persisted when the user leave group
			await GroupActions.instance.refreshGroupCache(GroupCacheOption.LIST, () => {
				// Invalidate query getGroupSpaceChatList
				queryClient.invalidateQueries({ queryKey: ["getGroupSpaceChatList"] });
			});
		} catch (_error) {
			const error = _error as Error;
			toast.show({ type: "error", message: error.message });
		}

		modal.hide(ModalID.LEAVE_MEMBER);
	};

	const handleCancel = () => {
		modal.hide(ModalID.LEAVE_MEMBER);
	};

	return (
		<S.Wrapper gap={10} horizonAlign="center">
			<S.Body horizonAlign="center">
				{/* <Typography.p typoSize="Title1_B">{T(`{{name}}`, { name })}</Typography.p> */}
				<Typography.p typoSize="Body2">
					{_T("{{spaceName}} 그룹을 탈퇴하시겠습니까?", { spaceName: name })}
				</Typography.p>
				<S.ErrorTypo typoSize="Body2">{_T("(가입 중인 스페이스가 있는 경우 자동 탈퇴)")}</S.ErrorTypo>
			</S.Body>
			<S.Footer horizonAlign="center" verticalAlign="center">
				<Button.Group>
					<Button filled="secondary" onClick={handleCancel}>
						{_T("취소")}
					</Button>
					<Button onClick={handleLeave}>{_T("확인")}</Button>
				</Button.Group>
			</S.Footer>
		</S.Wrapper>
	);
}
